import { KYMW0001OutputModel } from '../../kymw00/kymw0001/vo/kymw0001-output.model';
import { KYMW0002OutputModel } from '../../kymw00/kymw0002/vo/kymw0002-output.model';
import { KYMW0300Component } from './kymw0300.component';
import { FeatureCodeListModel } from './vo/feature-code-list.model';
import { KYMW0300InputModel } from './vo/kymw0300-input.model';
import { KYMW0300OutputModel } from './vo/kymw0300-output.model';

/**
 * 商品検索画面の値を管理するクラス
 *
 * @export KYMW0300Model
 * @class KYMW0300Model
 */
export class KYMW0300Model {
  KYMW0300Component: KYMW0300Component;

  // 値格納用
  public pcode = String('');
  public itemCode = String('');
  public janCode = String('');
  public makerName = String('');
  public guideGoodsNameList: string[] = [''];
  public guideStandardNameList: string[] = [''];
  public guideGoodsName = String('');
  public guideStandardName = String('');
  public ordrClientCode = String('');
  public ordrClientKanji = String('');
  public payeeClientCode = String('');
  public payeeClientKanji = String('');
  public classCode = String('');
  public middleClassCode = String('');
  public smallClassCode = String('');
  public registDateCheck = Boolean(false);
  public registDateFrom = String('');
  public registDateTo = String('');
  public updateDateCheck = Boolean(false);
  public updateDateFrom = String('');
  public updateDateTo = String('');
  public buyerCode = String('');
  public pcodeList = String('');
  public searchKbn = String('0');
  public whole = String('0');
  public seikyou1Selected = Boolean(false);
  public seikyou2Selected = Boolean(false);
  public seikyou3Selected = Boolean(false);
  public seikyou4Selected = Boolean(false);
  public seikyou5Selected = Boolean(false);
  public seikyou6Selected = Boolean(false);
  public seikyou7Selected = Boolean(false);
  public seikyou8Selected = Boolean(false);
  public allCoop = Boolean(false);
  public dataKbnFlg = Boolean(false);
  public dataKbnFlg_pcodeList = Boolean(false);
  public dataKbnFlg_itemCodeList = Boolean(false);
  public dummyGoodsSelected = true;
  public dutiesFormWeeklyDivSelected = Boolean(false);
  public dutiesFormSpotDivSelected = Boolean(false);
  public tabSelectedIndex = 0;
  public tagId: string[] = [];
  public tagOutput: KYMW0002OutputModel;
  public tagSearchType: string = <string>'AND';
  public goodsMark: string[] = [];
  public goodsMarkOutput: KYMW0001OutputModel;
  public goodsMarkSearchType: string = <string>'OR';
  public itemcodeList = String('');
  public coopCodeList: string[] = [];
  public admitStatus = String('');
  public orderCode = String('');
  public catalogId = String('');
  public mediumType = String('');
  public specialFeature = String('');
  public specialFeatureList: FeatureCodeListModel[] = [];
  public catalogMark: string[] = [];
  public catalogMarkOutput: KYMW0001OutputModel;
  public catalogMarkSearchType: string = <string>'OR';
  public pageNo: string[] = [];
  public pageInput: string = '';
  public duties: string[] = [];

  // 活性・非活性制御用
  public disabledspecialFeatureFlg: boolean = Boolean(true);
  public disabledPageNoFlg: boolean = Boolean(true);
  public disabledCatalogMarkFlg: boolean = Boolean(true);

  // 表示・非表示制御用
  // 企画関連条件
  public catalogConditionVisible = String('');

  /**
   * 呼び元の画面で使用するメソッド
   * 前回の検索条件を格納する
   * ※kymw1300は本メソッドを使用せず個別で格納
   * @param output 検索条件
   */
  public getKYMW0300SearchHistory(output: KYMW0300OutputModel): KYMW0300InputModel {
    const inputVO: KYMW0300InputModel = new KYMW0300InputModel();

    // 前回の検索条件を保持
    inputVO.pcode = output.pcode;
    inputVO.itemCode = output.itemCode;
    inputVO.janCode = output.janCode;
    inputVO.makerName = output.makerName;
    inputVO.guideGoodsNameList = output.guideGoodsNameList;
    inputVO.guideStandardNameList = output.guideStandardNameList;
    inputVO.tagId = output.tagId;
    inputVO.tagSearchType = output.tagSearchType;
    inputVO.goodsMark = output.goodsMark;
    inputVO.goodsMarkSearchType = output.goodsMarkSearchType;
    inputVO.dataKbnFlg = output.dataKbnFlg;
    inputVO.goodsDiv = output.goodsDiv;					// 商品区分
    inputVO.coopCodeList = output.coopCodeList;
    inputVO.buyerCode = output.buyerCode;
    inputVO.admitStatus = output.admitStatus;
    inputVO.registDateFrom = output.registDateFrom;
    inputVO.registDateTo = output.registDateTo;
    inputVO.updateDateFrom = output.updateDateFrom;
    inputVO.updateDateTo = output.updateDateTo;
    inputVO.classCode = output.classCode;
    inputVO.middleClassCode = output.middleClassCode;
    inputVO.smallClassCode = output.smallClassCode;
    inputVO.ordrClientCode = output.ordrClientCode;
    inputVO.ordrClientKanji = output.ordrClientKanji;
    inputVO.payeeClientCode = output.payeeClientCode;
    inputVO.payeeClientKanji = output.payeeClientKanji;
    inputVO.mediumType = output.mediumType;
    inputVO.orderCode = output.orderCode;
    inputVO.catalogId = output.catalogId;
    inputVO.specialFeature = output.specialFeature;
    inputVO.catalogCode = output.catalogCode;
    inputVO.catalogCodeSearchType = output.catalogCodeSearchType;
    inputVO.pageNo = output.pageNo;
    inputVO.duties = output.duties;
    inputVO.pcodeList = output.pcodeList;
    inputVO.itemCodeList = output.itemcodeList;
    inputVO.searchKbn = output.searchKbn;

    // 検索条件設定画面で再表示用
    inputVO.tagOutput = output.tagOutput;
    inputVO.goodsMarkOutput = output.goodsMarkOutput;
    inputVO.catalogMarkOutput = output.catalogMarkOutput;
    inputVO.pageInput = output.pageInput;
    
    return inputVO;
  }
}
